import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=f6735328&scoped=true&"
import script from "./ChatConversation.vue?vue&type=script&lang=js&"
export * from "./ChatConversation.vue?vue&type=script&lang=js&"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=f6735328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6735328",
  null
  
)

export default component.exports